import { API, graphqlOperation } from 'aws-amplify';

// Utility to extract error message from known patterns
function extractErrorMessage(input?: string): string | null {
  if (!input) return null;
  const patterns = [/Error: (.*?);/, /ERROR: (.*?);/];
  for (const pattern of patterns) {
    const match = input.match(pattern);
    if (match) return match[1];
  }
  return null;
}

// Define standard GraphQL base query function
export const baseQuery = async <TResponse = any, TVariables = Record<string, any>>(args: {
  body: any; // GraphQL DocumentNode or string
  variables?: TVariables;
}): Promise<
  | { data: TResponse }
  | {
      error: {
        message: string;
        status: number;
        originalResponse: unknown;
      };
    }
> => {
  try {
    const { body, variables } = args;
    const response: any = await API.graphql(graphqlOperation(body, variables || {}));

    // Check for GraphQL errors
    if (response.errors?.length > 0) {
      const error = response.errors[0];
      return {
        error: {
          message: extractErrorMessage(error.message) || error.message || 'An error occurred',
          status: 400,
          originalResponse: response,
        },
      };
    }

    // Success
    return { data: response.data as TResponse };
  } catch (err: any) {
    // Network or unexpected errors
    const message = extractErrorMessage(err?.errors?.[0]?.message) || err?.message || 'A network error occurred';

    return {
      error: {
        message,
        status: 500,
        originalResponse: err,
      },
    };
  }
};
